import React from "react";
import classNames from "classnames";

import SimpleBar from "simplebar-react";
import Menu from "./Menu";
import ToggleCompact from "../Toggle/Compact";
import ToggleSidebar from "../Toggle/Sidebar";
import { useLayout, useLayoutUpdate } from "./../LayoutProvider";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
function Sidebar({ userRole }) {
  const layout = useLayout();
  const layoutUpdate = useLayoutUpdate();
  const isEmployee = userRole === "Employee";
  const [isMobile, setIsMobile] = useState(false);
  // Check screen width on mount and on resize
  // useEffect(() => {
  //   const checkMobile = () => {
  //     setIsMobile(window.innerWidth < 992); // Bootstrap lg breakpoint
  //   };
  //   checkMobile(); // Run once
  //   window.addEventListener('resize', checkMobile);
  //   return () => window.removeEventListener('resize', checkMobile);
  // }, []);
  // const shouldRenderSidebar = !isEmployee || (isEmployee && layout.sidebarActive && isMobile);
  // const compClass = classNames({
  //   'nk-sidebar nk-sidebar-fixed': true,
  //   'is-compact': layout.sidebarCompact,
  //   'sidebar-active': layout.sidebarActive,
  //   [`is-${layout.sidebarVariant}`]: layout.sidebarVariant,
  // });

  const compClass = classNames({
    "nk-sidebar nk-sidebar-fixed": true,
    "is-compact": layout.sidebarCompact,
    "sidebar-active": layout.sidebarActive,
    [`is-${layout.sidebarVariant}`]: layout.sidebarVariant,
  });
  return (
    <>
      {layout.sidebarActive && (
        <div
          className="sidebar-overlay"
          onClick={layoutUpdate.sidebarMobile}
        ></div>
      )}
      <div className={compClass}>
        <div className="nk-sidebar-element nk-sidebar-head">
          <div className="nk-sidebar-brand">
            <a className="logo-link" href="/dashboard">
              <div className="logo-wrap">
                <img
                  src="/logo/logo-icon.png"
                  alt="logoicon"
                  className="logo-iconimg"
                />
                <img
                  src="/logo/logo-text.png"
                  alt="logofull"
                  className="logo-textimg"
                />
              </div>
            </a>
            <ToggleCompact />
            <ToggleSidebar />
          </div>
        </div>
        <div className="nk-sidebar-element nk-sidebar-body">
          <div className="nk-sidebar-content">
            <SimpleBar className="nk-sidebar-menu">
              <Menu />
            </SimpleBar>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "user",
});

export default connect(mapStateToProps)(Sidebar);
